import React from 'react';
import styled from 'styled-components';

const BigBackgroundSectionTitle = ({ children, style }) => {
  return (
    <H3 style={{ ...style }} className="big-background-section-title">
      {children}
    </H3>
  );
};

const H3 = styled.h2`
  display: none;

  @media screen and (min-width: 1000px) {
    display: block;
    font-size: 12.5rem;
    font-weight: 900;
    color: rgba(0, 0, 0, 0.1);
    position: absolute;
    text-transform: lowercase;
    ${({ style }) => style};
  }
`;

export default BigBackgroundSectionTitle;
